import { Result } from 'antd';

/** Página para un usuario autenticado sin permiso sobre la sección (HTTP 403). */
export function ForbiddenPage() {
  return (
    <Result
      status="403"
      title="Sin acceso"
      subTitle="Tu rol no tiene permiso para ver esta sección."
    />
  );
}
